import { Chrome, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import { CHROME_WEB_STORE_URL } from "@/config/extension";

export default function FloatingInstallButton() {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50 animate-in slide-in-from-bottom-2 duration-300">
      <div className="bg-background border border-border rounded-2xl shadow-2xl p-4 max-w-sm">
        <div className="flex items-start justify-between mb-3">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center">
              <Chrome className="w-4 h-4 text-primary" />
            </div>
            <div>
              <h4 className="font-semibold text-sm">Get Fendly Protection</h4>
              <p className="text-xs text-muted-foreground">Install Chrome Extension</p>
            </div>
          </div>
          <Button
            variant="ghost"
            size="sm"
            className="h-6 w-6 p-0 hover:bg-muted"
            onClick={() => setIsVisible(false)}
          >
            <X className="w-3 h-3" />
          </Button>
        </div>
        
        <Button 
          asChild 
          size="sm" 
          className="w-full bg-gradient-to-r from-[#00F5A0] to-[#0AEFFF] text-[#0A0F0D] font-semibold hover:opacity-90"
        >
          <a 
            href={CHROME_WEB_STORE_URL} 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2"
          >
            <Chrome className="w-4 h-4" />
            Install Extension
          </a>
        </Button>
        
        <p className="text-xs text-muted-foreground mt-2 text-center">
          Free • No credit card required
        </p>
      </div>
    </div>
  );
}
